import { Link } from 'react-router-dom';
import Seo from '@/components/feature/Seo';
import ContactForm from '@/pages/contact/components/ContactForm';

const contactInfos = [
  {
    icon: 'ri-mail-send-line',
    label: '编辑部邮箱',
    value: 'editor@baoliao.com',
    desc: '新闻线索、内容建议与更正需求',
  },
  {
    icon: 'ri-phone-line',
    label: '爆料热线',
    value: '400-000-2026',
    desc: '工作日 09:00 - 18:00 人工接听',
  },
  {
    icon: 'ri-time-line',
    label: '工作时间',
    value: '周一至周日 08:30 - 21:00',
    desc: '节假日值班编辑在线',
  },
  {
    icon: 'ri-map-pin-line',
    label: '办公地址',
    value: '北京市朝阳区新闻传媒大厦 18 层',
    desc: '来访请提前预约',
  },
];

export default function ContactPage() {
  return (
    <>
      <Seo
        title="联系我们-爆料网新闻爆料"
        description="欢迎通过邮箱、爆料热线或在线留言与爆料网编辑部取得联系，提供新闻线索、内容建议或合作意向。"
        keywords="联系爆料网,新闻线索,爆料热线,编辑部联系方式"
        path="/contact"
      />

      <section className="border-b border-background-200 bg-primary-950">
        <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
          <nav aria-label="面包屑导航" className="flex items-center gap-1 text-sm text-background-50/60">
            <Link to="/" className="hover:text-background-50">
              首页
            </Link>
            <i className="ri-arrow-right-s-line" />
            <span className="text-background-50">联系我们</span>
          </nav>
          <h1 className="mt-5 font-heading text-3xl font-black text-background-50 md:text-4xl">联系爆料网</h1>
          <p className="mt-3 max-w-2xl text-sm leading-7 text-background-50/80 md:text-base">
            有新闻线索想提供？对网站有建议？或者希望与我们展开合作？欢迎随时与爆料网编辑部联系。
          </p>
        </div>
      </section>

      <div className="mx-auto max-w-[1400px] px-4 py-10 md:px-6 md:py-14">
        <section className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {contactInfos.map((info) => (
            <div key={info.label} className="rounded-lg border border-background-200 bg-background-50 p-5">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className={`${info.icon} text-xl`} />
              </span>
              <h2 className="mt-4 text-sm text-foreground-500">{info.label}</h2>
              <p className="mt-1 font-heading text-base font-bold text-foreground-950">{info.value}</p>
              <p className="mt-1 text-xs leading-5 text-foreground-500">{info.desc}</p>
            </div>
          ))}
        </section>

        <section className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-[1.3fr_1fr]">
          <ContactForm />

          <div className="flex flex-col gap-6">
            <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <iframe
                title="爆料网办公地点地图"
                src="https://www.google.com/maps?q=Beijing%20CBD&output=embed"
                className="h-64 w-full border-0"
                aria-label="爆料网办公地点地图"
              />
              <div className="p-4">
                <h3 className="font-heading text-base font-bold text-foreground-950">到访指南</h3>
                <p className="mt-1 text-sm leading-6 text-foreground-500">
                  乘地铁可至国贸站，步行约 8 分钟即达。如需现场来访，请提前通过邮箱或热线预约。
                </p>
              </div>
            </div>

            <div className="rounded-lg border border-accent-300 bg-accent-50 p-5">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-accent-900">
                <i className="ri-lightbulb-flash-line" />
                如何提供有效线索？
              </h3>
              <ul className="mt-3 space-y-2 text-sm leading-6 text-accent-900/85">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-blank-circle-fill mt-1.5 text-[6px]" />
                  尽量说明事件发生的时间、地点与经过；
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-blank-circle-fill mt-1.5 text-[6px]" />
                  如有图片、视频等材料，请一并提供并注明来源；
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-blank-circle-fill mt-1.5 text-[6px]" />
                  留下可靠联系方式，方便编辑与你进一步核实。
                </li>
              </ul>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}